import { render, staticRenderFns } from "./editVehicleInsurance.vue?vue&type=template&id=55a130e8"
import script from "./editVehicleInsurance.vue?vue&type=script&lang=js"
export * from "./editVehicleInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports